import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LoadingStatus } from "../sessions/models/LoadingStatus";
import { ApiErrorResponse } from "../../api/types/ApiErrorResponse";
import { RootState } from "../../app/store";
import { PortalSettingsResponse } from "./contracts/PortalSettingsResponse";
import {
  fetchPortalSettings,
  updatePortalSettings,
} from "./slice-extensions/portal-settings-slice-extension";

interface PortalSettingsState {
  settings: PortalSettingsResponse | null;
  status: LoadingStatus;
  lastError?: ApiErrorResponse;
}

const initialState: PortalSettingsState = {
  settings: null,
  status: LoadingStatus.Idle,
  lastError: undefined,
};

const portalSettingsSlice = createSlice({
  name: "portalSettings",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPortalSettings.pending, (state) => {
        state.status = LoadingStatus.Loading;
        state.lastError = undefined;
      })
      .addCase(
        fetchPortalSettings.fulfilled,
        (state, action: PayloadAction<PortalSettingsResponse>) => {
          state.status = LoadingStatus.Idle;
          state.settings = action.payload;
        },
      )
      .addCase(fetchPortalSettings.rejected, (state, action) => {
        state.status = LoadingStatus.Failed;
        state.lastError = action.payload;
      });

    builder
      .addCase(updatePortalSettings.pending, (state) => {
        state.status = LoadingStatus.Loading;
        state.lastError = undefined;
      })
      .addCase(
        updatePortalSettings.fulfilled,
        (state, action: PayloadAction<PortalSettingsResponse>) => {
          state.status = LoadingStatus.Idle;
          state.settings = action.payload;
        },
      )
      .addCase(updatePortalSettings.rejected, (state, action) => {
        state.status = LoadingStatus.Failed;
        state.lastError = action.payload;
      });
  },
});

export const selectPortalSettings = (state: RootState) => state.portalSettings.settings;
export const selectPortalSettingsStatus = (state: RootState) => state.portalSettings.status;
export const selectPortalSettingsError = (state: RootState) => state.portalSettings.lastError;

export default portalSettingsSlice.reducer;
